import { createReducer, on } from '@ngrx/store';
import * as ProjectActions from './project.actions';
import { createProjectSuccess } from './project.actions';
import { ProjectDto } from '../../models/project.model';
import { LoadingState, ProjectState } from '../store.states';
import { createEntityAdapter } from '@ngrx/entity';

export const projectsAdapter = createEntityAdapter<ProjectDto>({
  selectId: (project) => project.id,
  sortComparer: false,
});

export const initialState: ProjectState = {
  projects: projectsAdapter.getInitialState(),
  loadingState: LoadingState.FUTURE,
  updateState: LoadingState.FUTURE,
  error: null,
  completed: false,
};

export const projectReducer = createReducer(
  initialState,
  on(ProjectActions.loadProjects, (state) => ({
    ...state,
    updateState: LoadingState.PENDING,
    error: null,
  })),

  on(ProjectActions.loadProjectsSuccess, (state, { projects }) => ({
    ...state,
    updateState: LoadingState.SUCCESS,
    projects: projectsAdapter.setAll(projects, state.projects),
  })),

  on(ProjectActions.loadProjectsError, (state, { error }) => ({
    ...state,
    loading: false,
    updateState: LoadingState.ERROR,
    error: error,
  })),

  on(ProjectActions.loadProjectById, (state) => ({
    ...state,
    loadingState: LoadingState.PENDING,
    error: null,
  })),

  on(ProjectActions.loadProjectByIdSuccess, (state, { project }) => ({
    ...state,
    loadingState: LoadingState.SUCCESS,
    projects: projectsAdapter.addOne(project, state.projects),
  })),

  on(ProjectActions.loadProjectByIdError, (state, { error }) => ({
    ...state,
    updateState: LoadingState.ERROR,
    error: error,
  })),

  on(createProjectSuccess, (state, { project }) => ({
    ...state,
    updateState: LoadingState.SUCCESS,
    projects: projectsAdapter.addOne(project, state.projects),
  })),

  on(ProjectActions.updateProjectSuccess, (state, { project }) => ({
    ...state,
    updateState: LoadingState.SUCCESS,
    projects: projectsAdapter.upsertOne(project, state.projects),
  })),
);
